export const inputRow = {
  padding: "5px",
};

export const submitbtnRow = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "1rem",
};

export const commonInputStyles: any = {
  className: "backgroundWhite-description",
  size: "small",
  variant: "outlined",
  fullWidth: true,
};

export const projectsOptions = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  gap: "1rem",
  padding: "10px",
  width: "100%",
};

export const projectsChip = {
  borderRadius: "5px",
};

export const companySeperatorStyle = {
  backgroundColor: "#d3d3d3",
  height: "1px",
  flex: "1",
  ml: "1rem",
};
